import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Allows a callback to be scheduled to run in the next effect.
 */
export function useScheduledEffect () {
  const [state, setState] = useState({})

  const callbacks = useRef(new Map<string, () => void>())
  const schedule = useCallback((id: string, callback: () => void) => {
    callbacks.current.set(id, callback)

    setState({})
  }, [])

  useEffect(() => {
    callbacks.current.forEach((callback) => callback())
    callbacks.current.clear()
  }, [state])

  return schedule
}
